<div *ngIf="question"
  class="p-3">

  <p>{{question?.questionText}}</p>
</div>
